import { Grid } from "@mui/material"
import { Create, required, SimpleForm, TextInput, useNotify, useRedirect, useTranslate } from "react-admin"
import { CardCommon } from "src/components/uiElements"
import { CardCrudBottomButtons } from "src/components/uiElements/CRUD/CardCrudBottomButtons"
import { EditInputsWrap } from "src/components/uiElements/CRUD/EditInputsWrap"

export const ExtAirAirlineCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.ext-air-airline') }
    })
    redirect('/ext-air-airline')
  }

  const onError = () => {
    notify('ra.notification.created_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.ext-air-airline') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_ext-air-airline')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput source='short_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}